
export const TransectionStatus = {
    FAIL: { code: 0, name: 'Failed' },
    EXPIRED: { code: 1, name: 'Expired' },
    PENDING: { code: 2, name: 'Pending' },
    SUCCESS: { code: 3, name: 'Successful' },
    REVERSED: { code: 4, name: 'Reversed' }
};

export const TransectionErrorType = {
    ERROR: 999, // error every thing
    SUCCESS: 300,
    NOT_FOUND_ORDER: 998,
    ORDER_FAILED: 601,
    ORDER_REVERSED: 602,
    ORDER_EXPIRED: 603,
    OMISE_CHARGE_NOT_SUCCESS: 701, // omise charge status !== 'successful' or 'pending'
    ORDER_PENDING: 702,
    UPDATE_STATUS_ORDER_FAIL: 801,
    CREATE_RECEIPT: 803,
    ADD_CREDIT_LOG: 804,
    INNTERNAL_ERROR: 805, // service save or update fail
    ERR_UPDATE_ACCPRICE: 809
};

export const TaxType = {
    INDIVIDUAL: 1,
    CORPORATE: 2
};

export const PackageType = {
    CUSTOM: 7,
    RECOMMEND: 6,
    DEFAULT: 1
}

export const PaymentMethod = {
    promtpay: { name: 'PromptPay', path: "qr-code" },
    truemoney: { name: 'True Money', path: "true-money" },
    mobile_banking_kbank: { name: 'K PLUS', path: "mobile_banking_kbank" },
    mobile_banking_bbl: { name: 'BBL', path: "mobile_banking_bbl" },
    mobile_banking_ktb: { name: 'KTB', path: "mobile_banking_ktb" },
    mobile_banking_scb: { name: 'SCB', path: "mobile_banking_scb" },
    mobile_banking_bay: { name: 'KMA', path: "mobile_banking_bay" },
    credit: { name: 'Credit Card', path: "card" },
    debit: { name: 'Debit Card', path: "card" }
}

export const PaymentMethodDisplay = {
    promptpay: { name: 'PromptPay', path: "qr-code" },
    truemoney: { name: 'True Money', path: "true-money" },
    mobilebankingkbank: { name: 'K PLUS', path: "mobile_banking_kbank" },
    mobilebankingbbl: { name: 'BBL', path: "mobile_banking_bbl" },
    mobilebankingktb: { name: 'KTB', path: "mobile_banking_ktb" },
    mobilebankingscb: { name: 'SCB', path: "mobile_banking_scb" },
    mobilebankingbay: { name: 'KMA', path: "mobile_banking_bay" },
    credit : { name: 'Credit Card', path: "card" },
    debit : { name: 'Debit Card', path: "card" }
}

export const PaymentStatus =
{
    0: {name: "Failed", color: "#EA5455", background: "#ebac931f"},
    1: {name: "Expired", color: "#F26622", background: "#f266221f"},
    2: {name: "Pending", color: "#19164F", background: "#19164F1f"},
    3: {name: "Successful", color: "#28C76F", background: "#28c76f1f"},
    4: {name: "Reversed", color: "#19164F", background: "#19164F1f"},
}

export const RequestFullTaxInvoice = {
    NotRequest: 2,
    Request: 1
}